import { useCallback, useState } from 'react';
import { camelCase } from 'lodash';
import { throttle } from 'lodash/fp';
import { useSelector } from 'react-redux';
import { SEARCH_TYPES } from '../../../../../utils/constants';
import { useAssignments } from '../../hooks/useAssignments';
import { ISGBody } from '../ISGBody/ISGBody';

export const Body = ({
  gradebookData,
  settings,
  studentId,
  getLaunchUrl,
  handleLocalLaunch,
  getStudentReportLink,
  timeOnTaskMap,
  hasStudentReport,
  isMobile,
  showPercent,
  latestActivityLaunch,
  isDropdownOpen,
  isChat = true,
}) => {
  const {
    searchType,
    searchPhrase,
    courseId,
    categories,
    categoryWeights: weights,
    individualStudentGradebookData: { currentStudent },
  } = useSelector((state) => state.gradebook);

  const [sortBy, setSortBy] = useState('dueDate');
  const [sortOrder, setSortOrder] = useState('asc');
  const [searchTerm, setSearchTerm] = useState(
    searchType === SEARCH_TYPES.ASSIGNMENTS ? searchPhrase : '',
  );

  const { categoriesData, course: courseData } = useAssignments({
    searchTerm,
    gradebookData,
    categories,
    weights,
    settings,
  });

  const handleSortClick = useCallback(
    (sortByType) => {
      const sortingBy = camelCase(sortByType);
      setSortBy(sortingBy);
      if (sortingBy === sortBy) {
        setSortOrder(sortOrder === 'asc' ? 'desc' : 'asc');
      } else {
        setSortOrder('desc');
      }
    },
    [sortBy, sortOrder],
  );

  const handleSearchChange = (e) => {
    const value = e.target?.value;
    setSearchTerm(value);
  };

  const throttledSearchChange = throttle(300, handleSearchChange);

  const resetSearch = () => {
    if (searchPhrase !== '' || searchTerm !== '') {
      setSearchTerm('');
    }
  };

  return (
    <ISGBody
      isChat={isChat}
      currentStudent={currentStudent}
      categoriesData={categoriesData}
      throttledSearchChange={throttledSearchChange}
      sortBy={sortBy}
      sortOrder={sortOrder}
      handleSortClick={handleSortClick}
      searchPhrase={searchTerm}
      resetSearch={resetSearch}
      handleSearchFocus={() => {}}
      studentId={studentId}
      courseData={courseData}
      timeOnTaskMap={timeOnTaskMap}
      courseId={courseId}
      showPercent={showPercent}
      getLaunchUrl={getLaunchUrl}
      handleLocalLaunch={handleLocalLaunch}
      hasStudentReport={hasStudentReport}
      getStudentReportLink={getStudentReportLink}
      isMobile={isMobile}
      latestActivityLaunch={latestActivityLaunch}
      settings={settings}
      isDropdownOpen={isDropdownOpen}
    />
  );
};
